import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithRedirect } from "firebase/auth";
import { getDatabase } from "firebase/database";
//require('dotenv').config();

const firebaseConfig = {
  apiKey: "AIzaSyCWMiR8mwkyW8Q56IEU2XrA51s_sLXclpU",
  authDomain: "uztrains-699fb.firebaseapp.com",
  databaseURL: "https://uztrains-699fb.firebaseio.com",
  projectId: "uztrains-699fb",
  storageBucket: "uztrains-699fb.appspot.com",
  messagingSenderId: "1062997302083",
  appId: "1:1062997302083:web:13acac7dec677406116df6",
  measurementId: "G-2YXCB7ZFHQ",
};

const app = initializeApp(firebaseConfig);

export const db = getDatabase(app);

const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });

export const signInWithGoogle = () => signInWithRedirect(getAuth(), provider);
